import { render, staticRenderFns } from "./SpinnerWrapper.vue?vue&type=template&id=62495c53&scoped=true"
import script from "./SpinnerWrapper.vue?vue&type=script&lang=js"
export * from "./SpinnerWrapper.vue?vue&type=script&lang=js"
import style0 from "./SpinnerWrapper.vue?vue&type=style&index=0&id=62495c53&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62495c53",
  null
  
)

export default component.exports